import React from 'react';
import styles from './RadioHtml.module.css';
import RadioHtmlOption from './RadioHtmlOption';
import Question from '../../../interfaces/question';
import { ChosenOptionAnswer } from '../../context/SurveyPageContext';
import GenericInfoDTO from '../../../interfaces/dto/genericInfoDTO';

export interface RadioButtonProps {
  question: Question;
  onChange: (newValue: number) => void;
  radioButtonAnswer: ChosenOptionAnswer | undefined;
  htmlOption: (options: GenericInfoDTO) => JSX.Element;
}

const RadioHtml: React.FunctionComponent<RadioButtonProps> = ({
  question,
  onChange,
  radioButtonAnswer,
  htmlOption,
}) => {
  const options = question.radioButtonOptions;
  const radioOptionId = radioButtonAnswer?.chosenOption?.id;

  return (
    <div className={`${styles.radioHmtlContainer}`}>
      {options.map((option) => (
        <RadioHtmlOption
          option={option}
          questionId={question.id}
          onChange={onChange}
          checked={radioOptionId === option.id}
          key={`radioHtmlOption-${option.id}`}
          grayedOut={!!(radioOptionId && radioOptionId !== option.id)}
        >
          {htmlOption(option)}
        </RadioHtmlOption>
      ))}
    </div>
  );
};

RadioHtml.displayName = 'RadioHtml';

export default RadioHtml;
